export default __webpack_public_path__ + "static/media/Bodryk.d706ad92.png";